import React from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { cookieToInitialState, WagmiProvider } from "wagmi";
import { wagmiAdapterConfig } from '../Config/WagmiConfig';

const queryClient = new QueryClient();

export function Web3ModalProvider({ children }) {
  const initialState = cookieToInitialState(wagmiAdapterConfig);

  return (
    <WagmiProvider
      config={wagmiAdapterConfig}
      initialState={initialState}
    >
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
